export default "__VITE_ASSET__86a6f48f__"